import React from "react";
import Login from "./login";

export default function Companylogin(props) {
  return <Login {...props} defaultTab="staff" />;
}
